"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncConnection = void 0;
const polling_1 = require("../polling");
const websockets_1 = require("../websockets");
const types_1 = require("./types");
__exportStar(require("./types"), exports);
class AsyncConnection {
    constructor({ mode, pollingConfig, webSocketConfig }) {
        this.getConnection = () => {
            switch (this.mode) {
                case types_1.AsyncConnectionMode.WEBSOCKET:
                    return this.getConnectionWebsocket();
                case types_1.AsyncConnectionMode.POLLING:
                    return this.getConnectionPolling();
                default:
                    throw new Error('[AsyncConnection] Invalid config: mode is incorrect');
            }
        };
        this.getConnectionWebsocket = () => {
            var _a;
            if ((_a = this.webSocketConfig) === null || _a === void 0 ? void 0 : _a.url) {
                return new websockets_1.WebSockets(this.webSocketConfig.url, this.webSocketConfig.protocols);
            }
            throw new Error('[AsyncConnection/WebSocket] Invalid config');
        };
        this.getConnectionPolling = () => {
            var _a;
            if ((_a = this.pollingConfig) === null || _a === void 0 ? void 0 : _a.getDataFn) {
                return new polling_1.Polling(this.pollingConfig.getDataFn, this.pollingConfig.sendDataFn, this.pollingConfig.interval, this.pollingConfig.maxAttempts);
            }
            throw new Error('[AsyncConnection/Polling] Invalid config');
        };
        this.mode = mode;
        this.webSocketConfig = webSocketConfig;
        this.pollingConfig = pollingConfig;
    }
}
exports.AsyncConnection = AsyncConnection;
//# sourceMappingURL=index.js.map